<template>
  <div class="userlist-page">
    <div class="shell">
      <header class="topbar">
        <button class="back-btn" type="button" @click="$router.back()">
          <span class="back-arrow">&#8592;</span>
        </button>
        <h1 class="page-title">Direct Referrals</h1>
        <div class="topbar-placeholder"></div>
      </header>

      <div v-if="!loading && userList.length === 0" class="list-empty">No direct referrals yet</div>

      <div class="list-meta" v-if="userList.length > 0">
        Total <b>{{ userList.length }}</b> direct referrals
      </div>

      <div class="list-item" v-for="item in userList" :key="item.address">
        <div class="item-main">
          <span class="item-addr">{{ shortAddress(item.address) }}</span>
          <span class="item-time">{{ formatDate(item.joined_at) }}</span>
          <span class="item-perf">{{ formatPerf(item.total_performance) }} USDT</span>
        </div>
      </div>

      <div v-if="loading" class="loading-tip">Loading...</div>
    </div>
  </div>
</template>

<script>
import { getDirects } from '@/api/auth'

export default {
  name: 'UserListPage',
  data() {
    return {
      userList: [],
      loading: false,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await getDirects()
        this.userList = Array.isArray(res.data) ? res.data : []
      } catch (e) {
        console.error('getDirects failed', e)
      } finally {
        this.loading = false
      }
    },
    shortAddress(addr) {
      if (!addr) return '—'
      return addr.slice(0, 6) + '...' + addr.slice(-4)
    },
    formatPerf(val) {
      if (val == null) return '--'
      return Number(val).toLocaleString('en-US', { maximumFractionDigits: 2 })
    },
    formatDate(val) {
      if (!val) return '--'
      return val.slice(0, 10)
    }
  }
}
</script>

<style lang="less" scoped>
.userlist-page {
  min-height: 100vh;
  color: #fff;
  background: radial-gradient(circle at 76% 6%, rgba(255, 67, 89, 0.28), rgba(16, 6, 12, 0) 38%),
    linear-gradient(180deg, #1a0510 0%, #11050f 40%, #0d0a16 100%);
}

.shell {
  max-width: 430px;
  margin: 0 auto;
  padding: 12px 14px 40px;
  box-sizing: border-box;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  color: #e5dce8;
  font-size: 15px;
  cursor: pointer;
  padding: 4px 0;
}

.back-arrow {
  font-size: 18px;
  line-height: 1;
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.topbar-placeholder {
  width: 48px;
}

.list-meta {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 12px;

  b {
    color: #fff;
  }
}

.list-empty {
  text-align: center;
  color: rgba(255, 255, 255, 0.3);
  font-size: 14px;
  padding: 48px 0;
}

.list-item {
  margin-bottom: 10px;
  padding: 10px 12px 11px;
  border-radius: 12px;
  border: 1px solid rgba(255, 86, 115, 0.25);
  background: linear-gradient(180deg, rgba(38, 22, 41, 0.95), rgba(25, 17, 33, 0.95));
}

.item-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item-addr {
  color: #e5dce8;
  font-size: 13px;
  font-weight: 500;
  word-break: break-all;
}

.item-time {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  flex: 1;
  text-align: center;
}

.item-perf {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  margin-left: 12px;
}

.item-tags {
  display: flex;
  gap: 6px;
}

.tag {
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.4);
  white-space: nowrap;

  &--active {
    background: rgba(229, 29, 69, 0.2);
    color: #e5dce8;
  }
}

.loading-tip {
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  padding: 16px 0;
}
</style>
